function createSelectPlaceholder(text) {
  let option = document.createElement('option');
  option.setAttribute('hidden', '');
  option.setAttribute('selected', '');
  option.setAttribute('disabled', '');
  option.setAttribute('value', 'default');
  option.innerHTML = text;
  return option;
}

export default function appendPlaceHolderToSelect(selectElement, text){
  let option = createSelectPlaceholder(text);
  selectElement.appendChild(option);
}
